import pxToRem from "../../functions/pxToRem";

export default function tabs({ colors, borders, boxShadows }) {
  const { grey, background } = colors;
  const { borderRadius } = borders;
  const { tabsBoxShadow } = boxShadows;

  const tabs = {
    styleOverrides: {
      root: {
        position: "relative",
        backgroundColor: grey[100],
        borderRadius: borderRadius.xl,
        minHeight: "unset",
        padding: pxToRem(4),
      },

      flexContainer: {
        height: "100%",
        position: "relative",
        zIndex: 10,
      },

      fixed: {
        overflow: "unset !important",
        overflowX: "unset !important",
      },

      vertical: {
        "& .MuiTabs-indicator": {
          width: "100%",
        },
      },

      indicator: {
        height: "100%",
        borderRadius: borderRadius.lg,
        backgroundColor: background.paper,
        boxShadow: tabsBoxShadow.indicator,
        transition: "all 500ms ease",
      },
    },
  };

  return tabs;
}
